// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled[data-v-02a7268b]{\n  pointer-events: none;\n}\n.indented[data-v-02a7268b]{\n  margin-left: 15px !important;\n}\n", ""]);
// Exports
module.exports = exports;
